import { render } from "./DashboardNav.vue?vue&type=template&id=19830764"
import script from "./DashboardNav.vue?vue&type=script&lang=js"
export * from "./DashboardNav.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__